
import { defineComponent } from "vue";
import router from "@/router";

import DimensionBasicDataTab from "./DimensionBasicDataTab.vue";
import PreschoolPerformancesContent from "./PreschoolPerformancesContent.vue";
import PreschoolPerformanceByPeriodContent from "./PreschoolPerformanceByPeriodContent.vue";

import { IPreschoolDimensionsModel } from "@/interfaces/modules";
import PreschoolDimensionsService from "@/api/Preschool/PreschoolDimensionsService";

export default defineComponent({
    name: "AcademicCompetenciesDetailView",
    components: {
        DimensionBasicDataTab,
        PreschoolPerformancesContent,
        PreschoolPerformanceByPeriodContent,
    },
    data() {
        return {
            activeTab: 0,
            dimensionId: 0,
            dimension: {} as IPreschoolDimensionsModel,
            loading: false,
            loaded: false,
        };
    },
    computed: {
        isNew(): boolean {
            return this.dimensionId > 0 ? false : true;
        },
    },
    async mounted() {
        const idParam = this.$route.params.Id as string | undefined;

        const id = idParam ? parseInt(idParam, 10) : 0;
        this.dimensionId = isNaN(id) ? 0 : id;

        if (!this.isNew) {
            await this.loadCompetency();
        }
        this.loaded = true;

    },
    methods: {
        setTab(index: number) {
            this.activeTab = index;
        },
        async loadCompetency() {
            this.loading = true;
            console.log(' this.dimensionId ', this.dimensionId);
            try {
                const result = await PreschoolDimensionsService.GetPreschoolDimensionById(this.dimensionId as any);
                this.dimension = result;
                this.loaded = false;
            } finally {
                this.loading = false;
            }
        },
        goBack() {
            router.back();
        }
    },
});
